import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';  
export default function BrandSection(){
    return(
        <section className="brand-area">
		<div className="brand-bg">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-lg-6">
						<div className="brand-title text-center mb-45">
							<h6 className="semi-title title-line">Happy Sponsors</h6>
							<h2 className="sect-title">2500 happy users around world</h2>
						</div>
					</div>
				</div>
			
                <div className="brand-slide mb-60">
		<OwlCarousel items={5}  
			className="owl-theme"  
			loop 
			dots={false}			  
			margin={30} 
			responsive= {
				{
					'1':{
						items: 2
					},
					'768': {
						items: 3
					},

					'1200': {
						items: 5
					}

				}
				
			}>
			<div className="brand-item">
				<a className="brand-img" href="#">
					<img className="mb-50 front" src="assets/img/brand/brand-1.png" alt="Brand" />
					<img className="mb-50 back" src="assets/img/brand/brand-1g.png" alt="Brand" />								
				</a>
			</div>
			<div className="brand-item">
				<a className="brand-img" href="#">
					<img className="mb-50 front" src="assets/img/brand/brand-2.png" alt="Brand" />
					<img className="mb-50 back" src="assets/img/brand/brand-2g.png" alt="Brand" />								
				</a>
			</div>
			<div className="brand-item">
				<a className="brand-img" href="#">
					<img className="mb-50 front" src="assets/img/brand/brand-3.png" alt="Brand" />
					<img className="mb-50 back" src="assets/img/brand/brand-3g.png" alt="Brand" />								
				</a>
			</div>
			<div className="brand-item">
				<a className="brand-img" href="#">
					<img className="mb-50 front" src="assets/img/brand/brand-4.png" alt="Brand" />
					<img className="mb-50 back" src="assets/img/brand/brand-4g.png" alt="Brand" />								
				</a>
			</div>
			<div className="brand-item">
				<a className="brand-img" href="#">
					<img className="mb-50 front" src="assets/img/brand/brand-5.png" alt="Brand" />
					<img className="mb-50 back" src="assets/img/brand/brand-5g.png" alt="Brand" />								
				</a>
			</div>
			</OwlCarousel>
		</div>
				
				<div className="row">
					<div className="col-12 text-center">
						<Link className="theme_btn" to="/contact">You Will Be Next?</Link>
					</div>
				</div>
			</div>
		</div>
	</section>
    )
}